@switch (treatmentType) {
  @case (ConsultationTreatmentTypes.Trt) {
    <app-sexual-performance-trt />
  }
  @case (ConsultationTreatmentTypes.TrtRenewal) {
    <app-sexual-performance-trt />
  }
  @case (ConsultationTreatmentTypes.Peptide) {
    <app-sexual-performance-peptide />
  }
  @case (ConsultationTreatmentTypes.PeptideRenewal) {
    <app-sexual-performance-peptide />
  }
  @case (ConsultationTreatmentTypes.HairLoss) {
    <app-sexual-performance-hair-loss />
  }
  @default {
    <app-sexual-performance />
  }
}
